import React from "react";

import i18next from "i18next";

import Dropdown from "components/Dropdown";
import { FileIcon } from "svg";

import { Badge, Nav } from "./styles";

type Props = {
  // @todo fix types
  unmappedItems: any;
  isVisible: boolean;
};

const PocNavItem = ({ unmappedItems, isVisible }: Props) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Nav.Item>
      <Badge>
        {unmappedItems === undefined ||
        unmappedItems === null ||
        !unmappedItems ? (
          <div className="loader" />
        ) : (
          <Badge
            style={{
              backgroundColor: "#1976d2",
              padding: "3px",
            }}
          >
            {unmappedItems}
          </Badge>
        )}
      </Badge>
      <Dropdown
        title={i18next.t("poc")}
        icon={FileIcon}
        items={[
          {
            label: i18next.t("create_poc_mapping"),
            to: "/create-poc-mapping",
          },
          {
            label: i18next.t("edit_poc_mapping"),
            to: "/mapping-history-poc",
          },
        ]}
      />
    </Nav.Item>
  );
};

export default PocNavItem;
